
import geocomply from './geocomply_lib/geocomply_wrapper'

export default geocomply;
